(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["addresses"]) return;
  try {
    
  const addBtn = document.getElementById('bp-add-address-btn');
  const newForm = document.getElementById('bp-new-address-form');
  const cancelBtn = document.getElementById('bp-cancel-new-address');
  if (addBtn && newForm) {
    addBtn.addEventListener('click', function() {
      newForm.style.display = newForm.style.display === 'none' ? 'block' : 'none';
      if (newForm.style.display === 'block') {
        newForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
  if (cancelBtn && newForm) {
    cancelBtn.addEventListener('click', function() {
      newForm.style.display = 'none';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    function updateCart(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.reload(); });
    }

    document.querySelectorAll('.bp-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.key;
        var input = document.querySelector('.bp-qty-input[data-key="' + key + '"]');
        var qty = parseInt(input.value);
        var newQty = this.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        input.value = newQty;
        updateCart(key, newQty);
      });
    });

    document.querySelectorAll('.bp-qty-input').forEach(function(input) {
      input.addEventListener('change', function() {
        updateCart(this.dataset.key, parseInt(this.value) || 0);
      });
    });

    document.querySelectorAll('.bp-cart-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateCart(this.dataset.key, 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bp-footer-col-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login"]) return;
  try {
    
  const recoverLink = document.querySelector('a[href="#recover"]');
  const mainCard = document.querySelector('.bp-auth-card:first-child');
  const recoverCard = document.getElementById('recover');
  if (recoverLink && mainCard && recoverCard) {
    recoverLink.addEventListener('click', function(e) {
      e.preventDefault();
      mainCard.style.display = 'none';
      recoverCard.style.display = 'block';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Galería de miniaturas
  document.querySelectorAll('.bp-thumb-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mainImg = document.getElementById('bp-main-img');
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = btn.dataset.src;
          mainImg.style.opacity = '1';
        }, 150);
      }
      document.querySelectorAll('.bp-thumb-btn').forEach(function (b) {
        b.classList.remove('bp-thumb-btn--active');
      });
      btn.classList.add('bp-thumb-btn--active');
    });
  });

  // Control de cantidad
  var input = document.getElementById('bp-qty-input');
  document.getElementById('bp-qty-minus').addEventListener('click', function () {
    if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
  });
  document.getElementById('bp-qty-plus').addEventListener('click', function () {
    if (input) input.value = parseInt(input.value) + 1;
  });

  // Selector de variantes visual
  function bpSetMainImage(url, srcset) {
    var mainImg = document.getElementById('bp-main-img');
    if (!mainImg || !url) return;

    mainImg.style.opacity = '0';
    setTimeout(function () {
      mainImg.src = url;
      if (srcset) {
        mainImg.srcset = srcset;
      } else {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
      }
      mainImg.style.opacity = '1';
    }, 150);
  }

  document.querySelectorAll('.bp-thumb-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      bpSetMainImage(btn.dataset.src);
      document.querySelectorAll('.bp-thumb-btn').forEach(function (b) {
        b.classList.remove('bp-thumb-btn--active');
      });
      btn.classList.add('bp-thumb-btn--active');
    });
  });

  document.querySelectorAll('.bp-variant-option input').forEach(function (radio) {
    radio.addEventListener('change', function () {
      document.querySelectorAll('.bp-variant-option').forEach(function (opt) {
        opt.classList.remove('bp-variant-option--active');
      });
      radio.parentElement.classList.add('bp-variant-option--active');
      bpSetMainImage(radio.getAttribute('data-image-url'), radio.getAttribute('data-image-srcset'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /* Sort sin recargar completo, preserva q */
  var sortSelect = document.getElementById('bp-search-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
